import { Utilidades } from 'src/app/shared/FuntionsGlobales/Utilidades';

/**
 * Espejo de `SatisfaccionMxRequest` en Swagger QAS (`/api/transportista/satisfaccion/set`).
 * `additionalProperties: false` — solo enviar claves listadas.
 */
export type SatisfaccionMxRequestBody = {
  rut_cliente?: string | null;
  nombreempresa?: string | null;
  rut_usuario?: string | null;
  nombreusuario?: string | null;
  email_usuario?: string | null;
  codobra?: string | null;
  nombreobra?: string | null;
  nro_guia?: string | null;
  comentario?: string | null;
  pregunta1?: string | null;
  puntos1?: string | null;
  pregunta2?: string | null;
  puntos2?: string | null;
  pregunta3?: string | null;
  puntos3?: string | null;
  pregunta4?: string | null;
  puntos4?: string | null;
  pregunta5?: string | null;
  puntos5?: string | null;
};

/** Misma lógica de saneamiento que headers legacy en EncuestaService.SaveEncuesta. */
export function legacySaveEncuestaDataToSatisfaccionMxBody(
  data: Record<string, unknown>
): SatisfaccionMxRequestBody {
  const preg = (data['pregunta'] as string[]) || [];
  const pts = String(data['puntos'] ?? '').split(',');

  return {
    rut_cliente: String(data['RutCli'] ?? ''),
    nombreempresa: String(data['NomEmp'] ?? ''),
    rut_usuario: String(data['RutUser'] ?? ''),
    nombreusuario: String(data['NomUser'] ?? ''),
    email_usuario: String(data['Email'] ?? ''),
    codobra: String(data['CodObra'] ?? ''),
    nombreobra: String(data['NombreObra'] ?? ''),
    nro_guia: String(data['NroGuia'] ?? ''),
    comentario: Utilidades.removeUnwantedCharacters(
      Utilidades.replaceSpecialCharacters(String(data['comentario'] ?? ''))
    ),
    pregunta1: Utilidades.replaceSpecialCharacters(String(preg[0] ?? '')),
    pregunta2: Utilidades.replaceSpecialCharacters(String(preg[1] ?? '')),
    pregunta3: Utilidades.replaceSpecialCharacters(String(preg[2] ?? '')),
    pregunta4: Utilidades.replaceSpecialCharacters(String(preg[3] ?? '')),
    puntos1: String(pts[0] ?? ''),
    puntos2: String(pts[1] ?? ''),
    puntos3: String(pts[2] ?? ''),
    puntos4: String(pts[3] ?? ''),
  };
}

